import { Injectable } from '@angular/core';
import { AuthenticationApi } from '../../shared/api.url';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiResponse } from '../../shared/models/api.response';
import { LoginModel, VerifyTwoFactorModel, ForgotPasswordModel } from './authentication.model';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {


  email: string;
  code: string;
  apiUrl = environment.apiBaseUrl
  constructor(public http: HttpClient) { }

  adminLogin(loginModel: LoginModel) {
    return this.http.post<ApiResponse>(this.apiUrl +AuthenticationApi.systemAdminlogin, loginModel);
  }

  forgotPassword(forgotPasswordModel: ForgotPasswordModel) {
    return this.http.post<ApiResponse>(this.apiUrl +AuthenticationApi.forgotPasswordApiUrl, forgotPasswordModel);
  }

  logout() {
    return this.http.get<ApiResponse>(this.apiUrl +AuthenticationApi.logOut);
  }

  verifyToken() {
    return this.http.get<ApiResponse>(this.apiUrl +AuthenticationApi.verifyToken);
  }

  clientLogin(loginModel: LoginModel) {
    return this.http.post<ApiResponse>(this.apiUrl +AuthenticationApi.clientLogin, loginModel);
  }

  verifyTwoFactorCode(loginModel: VerifyTwoFactorModel) {
    return this.http.post<ApiResponse>(this.apiUrl +AuthenticationApi.clientVerifyTwoFactorCode, loginModel);
  }

  doResetPassword(email: string, code: string) {
    let params = new HttpParams()
      .set('email', email)
      .set('code', code);
    var apiurl = this.http.get<ApiResponse>(this.apiUrl +AuthenticationApi.resetPassword, { params: params });
    return apiurl;
  }

  doSetPassword(model: any) {
    return this.http.post<ApiResponse>(this.apiUrl +AuthenticationApi.setPassword, model);
  }

  doRecoverSecurityCode(model: any) {
    return this.http.post<ApiResponse>(this.apiUrl +AuthenticationApi.doRecoverSecurityCodeApiUrl, model);
  }

  confirmMail(email: string, code: string) {
    let params = new HttpParams()
      .set('email', email)
      .set('code', code);

    return this.http.get<ApiResponse>(this.apiUrl +AuthenticationApi.confirmMail, { params: params });
  }

  confirmRecoverSecurityCode(email: string, code: string) {
    let params = new HttpParams()
      .set('email', email)
      .set('code', code);

    return this.http.get<ApiResponse>(this.apiUrl +AuthenticationApi.confirmRecoverSecurityCodeApiUrl, { params: params });
  }

  acceptTermsAndCondition(email: string) {
    let params = new HttpParams().set('email', email);

    return this.http.get<ApiResponse>(this.apiUrl +AuthenticationApi.acceptTermsPolicyApiUrl, { params: params });
  }

  reSendConfirmMail(email: string) {
    let params = new HttpParams()
      .set('email', email);

    return this.http.get<ApiResponse>(this.apiUrl +AuthenticationApi.reconfirmMail, { params: params });
  }

}
